[
  {
    "code": "IE-C",
    "name": "Connaught"
  },
  {
    "code": "IE-L",
    "name": "Leinster"
  },
  {
    "code": "IE-M",
    "name": "Munster"
  },
  {
    "code": "IE-U",
    "name": "Ulster"
  }
]